import { Home, CalendarToday, Euro, Lightbulb, LocalFireDepartment, Water, Bolt, Wifi, DriveEta, Chair } from '@mui/icons-material';

export const FORM_SECTIONS = {
  housing: {
    icon: Home,
    color: '#62B8E9',
    titleKey: 'Bostad & Anledning',
    fields: ['selectedApartment', 'reason'] // Removed selectedAssociation since it's automatically set
  },
  rentalPeriod: {
    icon: CalendarToday,
    color: '#62B8E9',
    titleKey: 'Uthyrningsperiod',
    fields: ['fromDate', 'toDate']
  },
  apartmentInfo: {
    icon: Home,
    color: '#62B8E9',
    titleKey: 'Lägenhetsinformation',
    fields: ['squareMeter', 'rooms']
  },
  economic: {
    icon: Euro,
    color: '#62B8E9',
    titleKey: 'Ekonomisk information',
    fields: ['rentalFee', 'deposit', 'clearingnummer', 'bankAccountNumber']
  },
  includedServices: {
    icon: Lightbulb,
    color: '#62B8E9',
    titleKey: 'Vad ingår i hyran?',
    fields: ['heatingIncluded', 'hotWaterIncluded', 'electricityIncluded', 'internetIncluded', 'parkingIncluded', 'furnitureIncluded']
  }
};

export const SERVICE_OPTIONS = {
  heating: {
    icon: LocalFireDepartment,
    color: '#E3F2FD',
    iconColor: '#62B8E9',
    title: 'Uppvärmning',
    category: 'essential'
  },
  hotWater: {
    icon: Water,
    color: '#E3F2FD',
    iconColor: '#62B8E9',
    title: 'Varmvatten',
    category: 'essential'
  },
  electricity: {
    icon: Bolt,
    color: '#E3F2FD',
    iconColor: '#62B8E9',
    title: 'Hushållsel',
    category: 'essential'
  },
  internet: {
    icon: Wifi,
    color: '#E3F2FD',
    iconColor: '#62B8E9',
    title: 'Internet',
    category: 'essential'
  },
  parking: {
    icon: DriveEta,
    color: '#E3F2FD',
    iconColor: '#62B8E9',
    title: 'Parkering',
    category: 'extra'
  },
  furniture: {
    icon: Chair,
    color: '#E3F2FD',
    iconColor: '#62B8E9',
    title: 'Möbler & inventarier',
    category: 'extra'
  }
};

export const FIELD_CONFIGS = {
  selectedAssociation: {
    labelKey: 'Välj förening',
    type: 'dropdown',
    placeholder: 'Välj förening...'
  },
  selectedApartment: {
    labelKey: 'Välj lägenhet',
    type: 'conditional-dropdown',
    placeholder: 'Välj lägenhet...',
    dependsOn: 'selectedAssociation'
  },
  reason: {
    labelKey: 'Anledning till uthyrning',
    type: 'dropdown',
    placeholder: 'Välj anledning...'
  },
  fromDate: {
    labelKey: 'Från datum',
    type: 'date'
  },
  toDate: {
    labelKey: 'Till datum',
    type: 'date'
  },
  squareMeter: {
    labelKey: 'Bostadsyta (m²)',
    type: 'number',
    placeholder: '75',
    unit: 'm²'
  },
  rooms: {
    labelKey: 'Antal rum',
    type: 'number',
    placeholder: '3'
  },
  rentalFee: {
    labelKey: 'Hyresavgift',
    type: 'number',
    placeholder: '12000',
    unit: 'kr/månad'
  },
  deposit: {
    labelKey: 'Deposition',
    type: 'number',
    placeholder: '24000',
    unit: 'kr'
  },
  clearingnummer: {
    labelKey: 'Clearingnummer',
    type: 'text',
    placeholder: '8000-0'
  },
  bankAccountNumber: {
    labelKey: 'Kontonummer',
    type: 'text',
    placeholder: '123 456 789'
  },
  bankgiro: {
    labelKey: 'Bankgiro',
    type: 'text',
    placeholder: '5555-5555'
  }
}; 